// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1B3Wy","title":"BackImages_title__QzBwI","images":"BackImages_images__6X4Tz"};